import React from 'react';

const Contact: React.FC = () => {
  return (
    <section id="contact" className="py-20 px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-soez-blue mb-4">Get in Touch</h2>
          <div className="w-20 h-1 bg-soez-orange mx-auto mb-6" />
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Ready to see SoEz in action? Let's discuss how we can transform your organization's communication.
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="bg-gray-50 p-12 rounded-xl">
            <h3 className="text-2xl font-bold text-soez-blue mb-6 text-center">Contact Our Team</h3>
            <p className="text-gray-600 mb-4 text-center">For partnership or product inquiries:</p>
            <a
              href="mailto:sales@soez.co.za"
              className="text-soez-orange text-2xl font-semibold block text-center hover:text-soez-orange-dark transition-colors"
            >
              sales@soez.co.za
            </a>
            <p className="text-gray-600 mt-8 text-center text-sm">We typically respond within 24 hours</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
